import { Routes, Route } from 'react-router-dom';
import './App.css';
import { Header } from './components/header/header';
import { Hero } from './pages/hero/hero';
import { Projectnamecoursel } from './pages/projectnamecoursel/projectnamecoursel';
import { Products } from './pages/products/products';
import { Aboutus } from './pages/aboutus/aboutus';
import { Footer } from './components/footer/footer';
import { FloatingWidgets } from './components/floatingWidgets/floatingWidgets';
import { AdminLayout } from './adminpanel/AdminLayout';

function MainSite() {
  return (
    <>
      <Header />
      <Hero />
      <Projectnamecoursel />
      <Products />
      <Aboutus />
      <Footer />
      <FloatingWidgets />
    </>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainSite />} />
      <Route path="/admin/*" element={<AdminLayout />} />
    </Routes>
  );
}

export default App;
